import { Component, OnInit, ViewEncapsulation, Input } from '@angular/core';

@Component({
	selector: 'app-slider-style1',
	templateUrl: './slider-style1.component.html',
	styleUrls: ['./slider-style1.component.scss'],
	encapsulation: ViewEncapsulation.None
})
export class SliderStyle1Component implements OnInit {

	constructor() { }

	ngOnInit() { }

}



// WEBPACK FOOTER //
// ./src/app/sliders/slider-style1/slider-style1.component.ts